
import { combineReducers } from 'redux';

import auth from '../common/client/reducers/auth';
import operationStatus from '../common/client/reducers/operationStatus';

import category from './category';
import info from './info';
import knData from './knData';
import list from './list';
import map from './map';
import project from './project';
import projectList from './projectList';
import search from './search';
import selection from './selection';

/*
import app from './app';
*/

export default combineReducers({
    auth,
    category: category(),
    operationStatus,
    info: info(),
    knData: knData(),
    list: list(),
    map,
    project: project(),
    projectList: projectList(),
    search: search(),
    selection: selection()
    /*
    app,
    */
});
